import React from 'react';
import { ReactComponent as ModalIcon } from '../../images/Icons/green_level.svg';

export default function ModalsHeaderNewLevelGreen() {

  return (
    <div>
      <div className="ModalsHeader green">
        <div>
          <ModalIcon />
        </div>
      </div>
      <div className="ModalsHeaderShadow"></div>
    </div>
  );
}
